// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Remove = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 28 28" fill="none" {...props}>
		<path d="M21.784 6.217c-4.29-4.29-11.276-4.29-15.567 0-4.29 4.29-4.29 11.276 0 15.567A10.972 10.972 0 0 0 14 25c2.818 0 5.638-1.072 7.782-3.217 4.292-4.291 4.292-11.277.002-15.567ZM20.92 20.92c-3.812 3.81-10.02 3.81-13.832 0-3.812-3.812-3.811-10.02 0-13.832 3.811-3.812 10.02-3.812 13.831 0 3.813 3.811 3.813 10.014 0 13.832Z" />
		<path d="M18.266 13.387h-8.53a.614.614 0 0 0-.613.612c0 .337.276.613.612.613h8.537a.614.614 0 0 0 .613-.613.614.614 0 0 0-.619-.612Z" />
	</svg>
);
export default Remove;
